var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showHeader ||
    _vm.mainElementMainImage ||
    _vm.showSlider ||
    _vm.mainElementVideo
    ? _c(
        "article",
        {
          directives: [
            {
              name: "observe-visibility",
              rawName: "v-observe-visibility",
              value: {
                callback: _vm.handleScrollIntoView,
                once: true
              },
              expression:
                "{\n    callback: handleScrollIntoView,\n    once: true,\n  }"
            }
          ],
          key: _vm.keyid,
          class: _vm.bemBlockMod(_vm.bannerClass),
          attrs: { "data-key": _vm.keyid, "data-banner-type": _vm.bannerType }
        },
        [
          _vm.showHeader
            ? _c("BaseTitleSubtitle", {
                class: _vm.bemElement("title-subtitle"),
                attrs: {
                  title: _vm.product.banner.mainElement.title,
                  subtitle: _vm.product.banner.mainElement.subtitle,
                  color: _vm.product.banner.mainElement.color
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.mainElementMainImage || _vm.mainElementVideo
            ? _c(
                "BaseLink",
                _vm._b(
                  {
                    class: _vm.bemElement("link"),
                    on: {
                      click: function($event) {
                        return _vm.mainElementClick()
                      }
                    }
                  },
                  "BaseLink",
                  _vm.product.banner.mainElement.link,
                  false
                ),
                [
                  _vm.mainElementVideo
                    ? _c("BaseVimeoVideo", {
                        class: _vm.bemElement("image"),
                        attrs: {
                          "video-desktop": _vm.mainElementVideo,
                          "video-mobile": _vm.mainElementVideo,
                          "video-poster-mobile":
                            _vm.mainElementMainImage[300].url,
                          "video-poster-desktop":
                            _vm.mainElementMainImage[1200].url,
                          "video-autoplay": true,
                          "video-muted": true,
                          "video-loop": true
                        }
                      })
                    : _c("BaseImage", {
                        class: _vm.bemElement("pic"),
                        attrs: {
                          "data-url": _vm.product.banner.mainElement.link.url,
                          "image-classes": _vm.bemElement("image"),
                          src: _vm.getDefaultImageUrlFromProductImageSet(
                            _vm.mainElementMainImage
                          ),
                          alt: _vm.getDefaultImageAltFromProductImageSet(
                            _vm.mainElementMainImage
                          ),
                          loading: _vm.forceMainImageToLoad ? "eager" : null,
                          placeholder: _vm.getPlaceholderImageUrlFromProductImageSet(
                            _vm.mainElementMainImage
                          ),
                          sizes: _vm.getSizes(),
                          srcset: _vm.getSrcsetFromProductImageSet(
                            _vm.mainElementMainImage
                          ),
                          "use-title": false
                        }
                      })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showSlider
            ? _c("BaseCarousel", {
                class: _vm.bemElement("slider"),
                attrs: {
                  "are-controls-shown": false,
                  items: _vm.sliderItems,
                  "swiper-options": {
                    allowTouchMove: true,
                    loop: false,
                    slidesPerView: 2.5,
                    spaceBetween: 2
                  }
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(slotProps) {
                        return [
                          _vm.isBreakpointMobile
                            ? _c("BaseProductTile", {
                                attrs: {
                                  analytics: {
                                    location:
                                      _vm.analyticsConst.location
                                        .plpSliderBanner,
                                    position:
                                      _vm.gridIndex + (slotProps.index + 1) / 10
                                  },
                                  "are-carousel-controls-shown": false,
                                  "carousel-index": slotProps.index,
                                  context: _vm.context,
                                  "force-main-image-to-load": true,
                                  "grid-index": _vm.gridIndex,
                                  "grid-type": _vm.gridType,
                                  "has-carousel": false,
                                  "hide-prices": _vm.hidePrices,
                                  "hide-product-names": _vm.hideProductNames,
                                  "hide-tags": _vm.hideTags,
                                  keyid:
                                    slotProps.item.id + "-" + slotProps.index,
                                  minimal: _vm.minimal,
                                  product: slotProps.item,
                                  "show-swatches": false,
                                  url: slotProps.item.selectedProductUrl || ""
                                }
                              })
                            : _vm.loadedProducts === null
                            ? _c("BaseProductTileImage", {
                                attrs: {
                                  "has-carousel": false,
                                  url: "",
                                  context: _vm.context,
                                  "force-main-image-to-load": true,
                                  product: _vm.toSliderSkeletonProduct(
                                    slotProps.item
                                  )
                                }
                              })
                            : _c("BaseProductTile", {
                                attrs: {
                                  analytics: {
                                    location:
                                      _vm.analyticsConst.location
                                        .plpSliderBanner,
                                    position:
                                      _vm.gridIndex + (slotProps.index + 1) / 10
                                  },
                                  "are-carousel-controls-shown": false,
                                  context: _vm.context,
                                  "force-main-image-to-load": true,
                                  "grid-index": _vm.gridIndex,
                                  "grid-type": _vm.gridType,
                                  "has-carousel": true,
                                  "hide-prices": _vm.hidePrices,
                                  "hide-product-names": _vm.hideProductNames,
                                  "hide-tags": _vm.hideTags,
                                  keyid:
                                    slotProps.item.id + "-" + slotProps.index,
                                  minimal: _vm.minimal,
                                  product: slotProps.item,
                                  "show-swatches": false,
                                  url: slotProps.item.selectedProductUrl || ""
                                }
                              })
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2687221844
                )
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }